import React from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'
import e from '../components/ExecutiveCommittee.json'
import v from '../components/VotingMembership.json'
import n from '../components/NonVotingMembership.json'
import l from '../components/LiasonOtherRegions.json'

const ExecCommittee = e.map(
    (info) => {
        return (
            <tr className='border-bottom' key={info.Incumbent}>
                <td className='ps-2 py-1'>{info.Office}</td>
                <td>{info.Incumbent}</td>
                <td>{info.Organization}</td>
            </tr>
        )
    }
)

const VotingMembership = v.map(
    (info) => {
        return (
            <tr className='border-bottom' key={info.Member}>
                <td className='ps-2 py-1'>{info.Category}</td>
                <td style={{width:'30%'}}>{info.Member} / {info['Date Joined']}</td>
                <td>{info.Organization}</td>
                <td>{info['County (Location of Interest)']}</td>
            </tr>
        )
    }
)

const NonVotingMembership = n.map(
    (info) => {
        return (
            <tr className='border-bottom' key={info.Members}>
                <td className='ps-2 py-2'>{info.Members}</td>
                <td>{info.Organization}</td>
            </tr>
        )
    }
)

const LiasonWithOtherRegions = l.map(
    (info) => {
        return (
            <tr className='border-bottom' key={info.Member}>
                <td className='ps-2 py-1'>{info.Member}</td>
                <td>{info.Region}</td>
                <td>{info['Region Name']}</td>
            </tr>
        )
    }
)



export default function PlanningGroup() {
    return (
        <div>

            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container mb-3'>
                    <div className='row ps-lg-4 px-2'>
                        <h3 className='mb-3'>Planning Group Members</h3>
                        <div className='row mb-4'>
                            <h4 className='mb-3'>Executive Committee</h4>
                            <table className='table table-striped'>
                                <thead>
                                    <tr className='text-light' style={{ backgroundColor: "#1F497D" }}>
                                        <th className='ps-2 text-light' style={{ backgroundColor: "#1F497D" }}>Office</th>
                                        <th className='text-light' style={{ backgroundColor: "#1F497D" }}>Incumbent</th>
                                        <th className='text-light' style={{ backgroundColor: "#1F497D" }}>Organization</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ExecCommittee}
                                </tbody>
                            </table>
                        </div>
                        <div className='row mb-4'>
                            <h4 className='mb-3'>Voting Membership</h4>
                            <table className='table table-striped'>
                                <thead>
                                    <tr className='text-light' style={{ backgroundColor: "#1F497D" }}>
                                        <th className='ps-2 text-light' style={{ backgroundColor: "#1F497D" }}>Category</th>
                                        <th className='text-light' style={{ backgroundColor: "#1F497D", width: "190px" }}>Member/Date Joined</th>
                                        <th className='text-light' style={{ backgroundColor: "#1F497D" }}>Organization</th>
                                        <th className='text-light' style={{ backgroundColor: "#1F497D" }}>County (Location of Interest)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {VotingMembership}
                                </tbody>
                            </table>
                        </div>
                        <div className='row mb-4'>
                            <h4 className='mb-3'>Non-Voting Membership</h4>
                            <table className='table table-striped'>
                                <thead>
                                    <tr className='text-light' style={{ backgroundColor: "#1F497D" }}>
                                        <th className='ps-2 text-light' style={{ backgroundColor: "#1F497D" }}>Members</th>
                                        <th className='text-light' style={{ backgroundColor: "#1F497D" }}>Organization</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {NonVotingMembership}
                                </tbody>
                            </table>
                        </div>
                        <div className='row mb-4'>
                            <h4 className='mb-3'>Liaison With Other Regions</h4>
                            <table className='table table-striped'>
                                <thead>
                                    <tr >
                                        <th className='ps-2 text-light' style={{ backgroundColor: "#1F497D" }}>Members</th>
                                        <th className='text-light' style={{ backgroundColor: "#1F497D" }}>Region</th>
                                        <th className='text-light' style={{ backgroundColor: "#1F497D" }}>Region Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {LiasonWithOtherRegions}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </main>

        </div>
    )
}
